export default "__VITE_ASSET__3a1ea735__"